"use client"

import { useContextEnrichmentPlugin } from "@/app/infra/amplitude"

const AMPLITUDE_CONTEXT = {
  page: "Drops",
}

export function DropsAnalyticsEnrichment() {
  useContextEnrichmentPlugin("DropsPageScopeProvider", AMPLITUDE_CONTEXT)

  return null
}
